
    export default {
    
        "./ListPanels": async () => {
          const importModule = await import("./src/pages/ListPanels/index.tsx")
          const exportModule = {}
          Object.assign(exportModule, importModule)
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      ,
        "./Panel": async () => {
          const importModule = await import("./src/pages/Panel/index.tsx")
          const exportModule = {}
          Object.assign(exportModule, importModule)
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      ,
        "./PanelAdd": async () => {
          const importModule = await import("./src/pages/PanelAdd/index.tsx")
          const exportModule = {}
          Object.assign(exportModule, importModule)
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      ,
        "./PanelEdit": async () => {
          const importModule = await import("./src/pages/PanelEdit/index.tsx")
          const exportModule = {}
          Object.assign(exportModule, importModule)
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      ,
        "./PanelPresentation": async () => {
          const importModule = await import("./src/pages/PanelPresentation/index.tsx")
          const exportModule = {}
          Object.assign(exportModule, importModule)
          Object.defineProperty(exportModule, "__esModule", {
            value: true,
            enumerable: false
          })
          return exportModule
        }
      
  }
  